class c extends window.HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.loadRecommendations()
  }
  loadRecommendations() {
    const s = this.dataset.productId,
      n = this.dataset.sectionId,
      t = this.dataset.limit || '4',
      a = this.dataset.intent || 'related'
    if (!s) return
    const r = `${window.Shopify.routes.root}recommendations/products?product_id=${s}&limit=${t}&section_id=${n}&intent=${a}`
    fetch(r)
      .then(e => {
        if (!e.ok) throw new Error(`HTTP error! status: ${e.status}`)
        return e.text()
      })
      .then(e => {
        const o = document.createElement('div')
        o.innerHTML = e
        const d = o.querySelector('product-recommendations')
        if (d && d.innerHTML.trim().length)
          ((this.innerHTML = d.innerHTML), this.classList.add('loaded'))
        else
          try {
            const i = JSON.parse(e)
            i.products && i.products.length > 0
              ? this.renderJSONRecommendations(i.products)
              : (this.style.display = 'none')
          } catch {
            this.style.display = 'none'
          }
      })
      .catch(e => {
        ;(console.error('Failed to load recommendations:', e),
          (this.style.display = 'none'))
      })
  }
  renderJSONRecommendations(s) {
    const n = `
      <div class='mt-16'>
        <h2 class='text-2xl font-serif mb-8'>You might also like</h2>
        <div class='grid grid-cols-1 md:grid-cols-3 gap-8'>
          ${s
            .slice(0, 3)
            .map(
              t => `
            <div class='product-card-wrapper'>
              <div class='product-card'>
                <div class='product-image aspect-square bg-gray-100 rounded-lg overflow-hidden mb-4 image relative'>
                  ${
                    t.featured_image
                      ? `
                    <img src="${t.featured_image}" alt="${t.title}" class="w-full h-full object-cover" loading="lazy">
                  `
                      : ''
                  }
                </div>
                <h3 class='font-serif text-2xl lg:text-4xl lg:text-left text-center'>
                  <a href="${t.url}" class='underline product-card-link'>
                    ${t.title}
                  </a>
                </h3>
                <div class='text-lg mt-2'>
                  $${(t.price / 100).toFixed(2)}
                </div>
              </div>
            </div>
          `
            )
            .join('')}
        </div>
      </div>
    `
    ;((this.innerHTML = n), this.classList.add('loaded'))
  }
}
window.customElements.define('product-recommendations', c)
export { c as default }
